import { onCLS, onINP, onFCP, onLCP, onTTFB, Metric } from 'web-vitals';

/**
 * Reports web vitals metrics
 * @param onPerfEntry - Optional callback function for performance metrics
 * @returns void
 */
function reportWebVitals(onPerfEntry?: (metric: Metric) => void): void {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS(onPerfEntry)
    onINP(onPerfEntry)
    onFCP(onPerfEntry)
    onLCP(onPerfEntry)
    onTTFB(onPerfEntry)
  }
}

export default reportWebVitals
